import { useState, useEffect } from "react";
import { DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from "@/components/ui/dialog";
import { GuardedDialog, isDirty } from "@/components/support/GuardedDialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

const EMPTY = { name: "", title: "", email: "", phone: "", notes: "", is_primary: false };

export const ContactDialog = ({ open, onOpenChange, contact, onSave, saving }) => {
  const [f, setF] = useState(EMPTY);
  const [init, setInit] = useState(EMPTY);
  useEffect(() => {
    if (!open) return;
    const v = contact ? Object.fromEntries(Object.keys(EMPTY).map((k) => [k, contact[k] ?? EMPTY[k]])) : EMPTY;
    setF(v); setInit(v);
  }, [open, contact]);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const inactive = contact && contact.active === false;
  const field = (k, label, props = {}) => (
    <div>
      <Label className="text-xs text-zinc-400">{label}</Label>
      <Input data-testid={`contact-${k}-input`} value={f[k]} onChange={(e) => set(k, e.target.value)} className="mt-1 bg-black border-zinc-800" {...props} />
    </div>
  );

  return (
    <GuardedDialog open={open} onOpenChange={onOpenChange} dirty={isDirty(f, init)} className="bg-zinc-900 border-white/10 max-w-lg" testid="contact-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">{contact ? "Edit contact" : "Add contact"}</DialogTitle>
          <DialogDescription className="text-zinc-400 text-sm">People at this customer you work with. Past tickets and time entries are never affected by changes here.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-1">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {field("name", "Name *", { autoFocus: true })}
            {field("title", "Job title / role")}
            {field("email", "Email", { type: "email" })}
            {field("phone", "Phone", { type: "tel" })}
          </div>
          <div>
            <Label className="text-xs text-zinc-400">Notes (optional)</Label>
            <Textarea data-testid="contact-notes-input" value={f.notes} onChange={(e) => set("notes", e.target.value)} rows={2} className="mt-1 bg-black border-zinc-800" />
          </div>
          <label className={`flex items-center gap-2 text-sm ${inactive ? "opacity-50" : "cursor-pointer"}`}>
            <Checkbox data-testid="contact-primary-checkbox" checked={!!f.is_primary} disabled={inactive} onCheckedChange={(v) => set("is_primary", !!v)} />
            Primary contact for this customer
          </label>
        </div>
        <DialogFooter className="gap-2">
          <DialogClose asChild><Button variant="ghost" data-testid="contact-cancel-button" className="text-zinc-400">Cancel</Button></DialogClose>
          <Button data-testid="contact-save-button" disabled={saving || !f.name.trim()} onClick={() => onSave(f)} className="bg-blue-600 hover:bg-blue-500">{saving ? "Saving…" : "Save contact"}</Button>
        </DialogFooter>
    </GuardedDialog>
  );
};
